<div class="container">
  <div *ngIf="isGeneratingResult">
    <h1>Deine Antworten werden ausgewertet</h1>
    <app-progress-loader [duration]="15000" [messages]="['Deine Antworten werden analysiert ✨', 'Einen Moment Geduld bitte 😉', 'Die KI macht eine kurze Kaffeepause ☕', 'Gutes braucht seine Zeit 💡']"></app-progress-loader>
  </div>

  <div *ngIf="!isGeneratingResult">
    <div class="header">
      <h1>Dein Ergebnis</h1>
      <h2>{{exam.score}}%</h2>
    </div>
    
    <app-exam-result-list [exam]="exam"></app-exam-result-list>
    <br><br><br>
  </div>
</div>